import {useTranslation} from 'react-i18next';

import {Box, Grid, SxProps, Typography} from '@mui/material';
import {Variant} from '@mui/material/styles/createTypography';

import {CultureTypeImage} from '../CultureTypeImage/CultureTypeImage';

import empion_mark_light from '../../assets/empion_mark_light.png';
import {greenColors} from '../../layouts/theme/designSystem';

interface Props {
  name?: string;
  url?: string;
  shouldDisplayEmpionLogo?: boolean;
  imageSize?: string;
  minWidth?: string;
  sx?: SxProps;
  typographyVariant?: Variant;
  isXSmall?: boolean;
  isMobile?: boolean;
  isTransparentBackground?: boolean;
}

export const CultureTypeCard = ({
  name,
  url,
  imageSize,
  shouldDisplayEmpionLogo = true,
  minWidth,
  sx,
  typographyVariant = 'h1',
  isXSmall,
  isTransparentBackground,
  isMobile,
}: Props) => {
  const {t} = useTranslation();
  const styles = {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    borderRadius: '10px',
    ...(!isTransparentBackground && {backgroundColor: 'background.paper'}),
    ...(!isTransparentBackground && {
      backgroundImage: 'linear-gradient(to top left, #FFFFFF 60%, #E7E2DE 100%)',
    }),
    padding: isXSmall ? '0px' : '32px',
  };

  return (
    <Grid item minWidth={minWidth} sx={sx}>
      <Box sx={styles}>
        <Typography variant='body1' sx={{color: greenColors[100]}}>
          {t('companyCultureDashboard.cultureType')}
        </Typography>
        <Typography variant={typographyVariant}>{name}</Typography>
        <Grid item display={'flex'} justifyContent={'center'}>
          <CultureTypeImage
            isMobile={isMobile}
            isXsmall={isXSmall}
            src={url}
            sx={{...(imageSize && {height: imageSize, width: 'auto'})}}
          />
        </Grid>
        {shouldDisplayEmpionLogo && (
          <Box
            component='img'
            src={empion_mark_light}
            alt='Empion logo rotated to the right'
            sx={{height: '40px', width: '40px', alignSelf: 'self-end'}}
          />
        )}
      </Box>
    </Grid>
  );
};
